export default __webpack_public_path__ + "static/media/logo-cl-small.c154553f.svg";